<template>
    <div class="footerV1-wrap section-gap">
        <v-container grid-list-xl py-0>
            <div class="footer-top">
                <v-layout row wrap>
                    <v-flex xs12 sm12 md4 lg4 xl4>
                        <div class="about-wrap">
                            <h6 class="white--text mb-6">{{ title }}</h6>
                            <span class="white--text">{{ description }}</span>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg4 xl2>
                        <h6 class="white--text mb-4">Acerca de</h6>
                        <div class="abt-menu">
                            <ul class="list-unstyled pl-0">
                                <li v-for="(list, key) in about" :key="key">
                                    <router-link :to="list.path">{{ list.menuItem }}</router-link>
                                </li>
                            </ul>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg4 xl2>
                        <h6 class="white--text mb-4">Session</h6>
                        <div class="features-menu">
                            <ul class="list-unstyled pl-0">
                                <li v-for="(list, key) in session" :key="key">
                                    <router-link :to="list.path">{{ list.menuItem }}</router-link>
                                </li>
                            </ul>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg4 xl2>
                        <h6 class="white--text mb-4">Categorías</h6>
                        <div class="policy-menu">
                            <ul class="list-unstyled pl-0">
                                <li v-for="(list, key) in categories" :key="key">
                                    <router-link :to="list.path">{{ list.menuItem }}</router-link>
                                </li>
                            </ul>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg4 xl2 >
                        <div class="policy-menu">
                            <h6 class="white--text mb-4">Redes</h6>
                            <ul class="list-unstyled pl-0">
                                <li v-for="(list, key) in socialLinks" :key="key">
                                    <a :href="list.path" target="_blank">{{ list.menuItem }}</a>
                                </li>
                            </ul>
                        </div>
                    </v-flex>
                </v-layout>
            </div>
            <hr />
            <div class="footer-bottom">
                <div class="footer-bottom-content px-3">
                    <v-layout row wrap align-center justify-space-between>
                        <v-flex xs12 sm12 md6 lg6 xl6 class="text-md-left text-center">
                            <img :src="img" width="218" height="18" />
                        </v-flex>
                        <v-flex xs12 sm12 md6 lg6 xl6 py-3 px-2>
                            <div class="text-md-right text-center">
                                <span class="white--text">{{ copyrightText }}</span>
                            </div>
                        </v-flex>
                    </v-layout>
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
import AppConfig from 'Constants/AppConfig';

export default {
    props: ['title', 'description', 'img'],
    data() {
        return {
            about: [
                {
                    menuItem: 'Nosotros',
                    path: '/',
                },
                {
                    menuItem: 'Terminos y condiciones',
                    path: '/',
                },
                {
                    menuItem: 'Politica de privacidad',
                    path: '/politicas-de-privacidad',
                },
                // {
                //     menuItem: 'Preguntas frecuentes',
                //     path: '/',
                // },
            ],
            session: [
                {
                    menuItem: 'Login',
                    path: '/login',
                },
                {
                    menuItem: 'Registrase',
                    path: '/',
                },
                {
                    menuItem: 'Olvidé mi contrseña',
                    path: '/',
                },
            ],
            categories: [
                {
                    menuItem: 'Restaurantes',
                    path: '/',
                },
                {
                    menuItem: 'Tienda retail',
                    path: '/',
                },
                {
                    menuItem: 'Distribuidoras',
                    path: '/',
                },
            ],
            socialLinks: [
                {
                    menuItem: 'Facebook',
                    path: 'https://www.facebook.com/',
                },
                {
                    menuItem: 'Twitter',
                    path: 'https://twitter.com/',
                },
                {
                    menuItem: 'Youtube',
                    path: 'https://www.youtube.com/',
                },
            ],
            copyrightText: AppConfig.copyrightText,
        };
    },
};
</script>
